
/** @title Tamanho da margem */
export type Size =
    | '0px'
    | '1px'
    | '2px'
    | '4px'
    | '8px'
    | '16px'
    | '24px'
    | '32px'
    | '40px'
    | '64px'
    | '128px'

/** @title Configurações da seção */
export interface Props {
    /** @title Tamanho */
    size?: {
        desktop?: Size
        mobile?: Size
    }
}

export function loader(props: Props & { isMobile?: boolean }) {
    return { ...props, isMobile: props.isMobile ?? false }
}

function Space({ size, isMobile }: ReturnType<typeof loader>) {
    const { desktop, mobile } = size ?? {}

    const height = isMobile ? mobile : desktop

    return <div className='w-full bg-transparent' style={{ height }} />
}

export default Space
export { default as LoadingFallback } from "~/components/LoadingFallback"

export const sync = true;
